<template>
    <div>
        <template v-for="(proAchievement, paIndex) in studentAchievementData">
            <div class="card" :class="{'mt-3': paIndex !== 0}">
                <div class="card-header">
                    {{proAchievement.achievementName}}
                </div>
                <div class="card-body" v-if="proAchievement.studentAchievementData.length === 0">
                    <div class="alert alert-warning mb-0">还没有【{{proAchievement.achievementName}}】成果物文件，请上传添加</div>
                </div>
                <table v-else class="table table-bordered mb-0">
                    <thead>
                    <tr>
                        <th class="text-center align-middle" style="width: 10%">序号</th>
                        <th class="text-center align-middle" style="width: 40%">文件名</th>
                        <th class="text-center align-middle" style="width: 20%">文件类型</th>
                        <th class="text-center align-middle" style="width: 20%">备注</th>
                        <th class="text-center align-middle" style="width: 10%">编辑</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(file, index) in proAchievement.studentAchievementData" :key="file.attFileId">
                        <td class="text-center align-middle">{{ index + 1 }}</td>
                        <td class="text-left align-middle">
                            <a :href="URL_DOWNLOAD + file.attFileId" target="_blank">{{ file.sourceFileName }}</a>
                        </td>
                        <td class="text-center align-middle">{{ file.attFileCategoryName }}</td>
                        <td class="text-left align-middle">{{ file.memo }}</td>
                        <td class="text-center align-middle">
                            <button class="btn btn-danger" @click="btnDeleteAttFile(file.attFileId)">删除</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="card-footer text-center">
                    <button class="btn btn-primary" @click="btnUpload_Click(proAchievement.achievementId)">上传</button>
                </div>
            </div>
        </template>
        <input type="file" name="uploadFile" style="display: none"
               ref="uploadFile" @change="uploadFileChange">

        <b-modal v-model="isAddAttFileDialogOpen"
                 title="添加批次文件"
                 ok-title="确定" cancel-title="取消" @ok="addAttFileInfoDialog_OK"
                 :no-close-on-backdrop="true">
            <div class="form-group row">
                <label for="inputAttSourceFileName" class="col-sm-3 col-form-label text-right">文件名</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="inputAttSourceFileName"
                           v-model="addAttFileInfo.sourceFileName" disabled>
                </div>
            </div>
            <div class="form-group row">
                <label for="inputAttAddress" class="col-sm-3 col-form-label text-right">附件地址</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="inputAttAddress" v-model="addAttFileInfo.address"
                           disabled>
                </div>
            </div>
            <div class="form-group row mb-0">
                <label for="inputAttMemo" class="col-sm-3 col-form-label text-right">备注</label>
                <div class="col-sm-8">
                        <textarea type="text" class="form-control" id="inputAttMemo" placeholder="备注"
                                  v-model="addAttFileInfo.memo" rows="3"></textarea>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
import dictionary from "@/utils/dictionary";
import commonApi from "@/utils/api/common";
import url from "@/utils/api/url";
export default {
    name: "StudentAchievmentEdit",
    props: {
        projectId: {type: String, required: true},

        userId: {type: String, required: true},
        userName: {type: String, required: true},
        userType: {type: Number, required: true}
    },
    data: function () {
        return {
            URL_DOWNLOAD: url.URL_DOWNLOAD,
            attFileType: dictionary.attFileType,

            studentAchievementData: [],

            currentAchievementId: '',
            addAttFileInfo: {
                attFileCategory: dictionary.attFileCategory.ACHIEVEMENT_FILE,
                ownerId: this.currentAchievementId,
                userId: this.userId,
                userName: this.userName,
                userType: this.userType,
                fileName: '',
                sourceFileName: '',
                path: '',
                address: '',
                physicalPath: '',
                physicalAddress: '',
                fileType: 9,
                memo: ''
            },
            isAddAttFileDialogOpen: false,
        };
    },
    mounted() {
        this.getStudentAchievementDataByStudentId();
    },
    methods: {
        getStudentAchievementDataByStudentId() {
            studyApi.achievement.getStudentAchievementDataByStudentId(this.userId, this.projectId).then(res => {
                this.studentAchievementData = res.data;
            });
        },

        btnUpload_Click(achievementId) {
            this.currentAchievementId = achievementId;

            this.addAttFileInfo = {
                attFileCategory: dictionary.attFileCategory.ACHIEVEMENT_FILE,
                ownerId: this.currentAchievementId,
                userId: this.userId,
                userName: this.userName,
                userType: this.userType,
                fileName: '',
                sourceFileName: '',
                path: '',
                address: '',
                physicalPath: '',
                physicalAddress: '',
                fileType: 9,
                memo: ''
            };
            this.$refs.uploadFile.click();
        },
        uploadFileChange($event) {
            let file = $event.target.files[0];
            commonApi.file.uploadFile(file, 'StudentAchievementFile').then(res => {
                // console.log(res.data);
                let info = res.data;

                this.addAttFileInfo.fileName = info.fileName;
                this.addAttFileInfo.sourceFileName = info.sourceFileName;
                this.addAttFileInfo.path = info.path;
                this.addAttFileInfo.address = info.address;
                this.addAttFileInfo.physicalPath = info.physicalPath;
                this.addAttFileInfo.physicalAddress = info.physicalAddress;
                if (info.fileName.toLowerCase().endsWith('.pdf')) {
                    this.addAttFileInfo.fileType = dictionary.attFileType.PDF_FILE
                }

                this.isAddAttFileDialogOpen = true;
                this.$refs.uploadFile.value = '';
            });
        },
        addAttFileInfoDialog_OK() {
            commonApi.attFile.insertAttFileInfo(this.addAttFileInfo).then(res => {
                this.getStudentAchievementDataByStudentId();
            });
        },
        btnDeleteAttFile(attFileId) {
            if (confirm('是否删除此附件文件？')) {
                commonApi.attFile.deleteAttFileInfoById(attFileId).then(res => {
                    this.getStudentAchievementDataByStudentId();
                });
            }
        },

    }
}
</script>

<style scoped>

</style>